export const REGISTRATION_CODE_NAME = "registration_code";

export function isRegistrationCodePresent(query) {
  return REGISTRATION_CODE_NAME in query;
}

export function getRegistrationCode(query) {
  return query[REGISTRATION_CODE_NAME];
}
